import Vue from 'vue'
import VueRouter from 'vue-router'
import { components } from 'aws-amplify-vue';// eslint-disable-line
import Amplify, * as AmplifyModules from 'aws-amplify';// eslint-disable-line
import { AmplifyPlugin } from 'aws-amplify-vue';
import Vuelidate from 'vuelidate'
import moment from 'vue-moment'

import { Hub } from "@aws-amplify/core"
//import Auth from "@aws-amplify/auth"

import MyPage from '../views/Mypage.vue'
import StaffPage from '../views/StaffPage.vue'
import CustomAuth from '../views/CustomAuth.vue'
import CustomChangePassword from '../views/CustomChangePassword.vue'
import MyMachineList from '../views/MyMachineList.vue'
import DeliverableList from '../views/DeliverableList.vue'
import MyMachine from '../views/MyMachine.vue'
import MyAircraft from '../views/MyAircraft.vue'
import SelectMachineType from '../views/SelectMachineType.vue'
import SelectApplicationType from '../views/SelectApplicationType.vue'
import SelectQuoteType from '../views/SelectQuoteType.vue'
import SelectSpotSamplingType from '../views/SelectSpotSamplingType.vue'
import MyMachineQRCode from '../views/MyMachineQRCode.vue'
import Sampling from '../views/Sampling.vue'
import SpotSampling from '../views/SpotSampling.vue'
import Application from '../views/Application.vue'
import ReferApplication from '../views/ReferApplication.vue'
import EmployeeList from '../views/EmployeeList.vue'
import Employee from '../views/Employee.vue'
import OrderSheet from '../views/OrderSheet.vue'
import OrderSheet4LabelSheet from '../views/OrderSheet4LabelSheet.vue'
import OrderSheet4LabelSheetJET from '../views/OrderSheet4LabelSheetJET.vue'
import OrderSheet4LabelSheetFrame from '../views/OrderSheet4LabelSheetFrame.vue'
import BarCodeSheet from '../views/BarCodeSheet.vue'
import FAQ from '../views/faq.vue'
import UserManual from '../views/UserManual.vue'
import ChangeOffice from '../views/ChangeOffice.vue'
import ApplicationJXTG from '../views/Application_JXTG.vue'
import BarCodeSample from '../views/BarCodeSample.vue'
import Quote from '../views/Quote.vue'
import QuoteSeet from '../views/QuoteSheet.vue'
import ReferQuote from '../views/ReferQuote.vue'

import MaintenamceMenu from '../views/MaintenanceMenu.vue'
import MainteAnalizeSet from '../views/MainteAnalizeSet.vue'
import MainteAnalizeItem from '../views/MainteAnalizeItem.vue'
import MainteInformation from '../views/MainteInformation.vue'
import MainteOutbox from '../views/MainteOutbox.vue'
import MainteDeliverables from '../views/MainteDeliverables.vue'
import MainteCompany from '../views/MainteCompany.vue'
import MainteEmployee from '../views/MainteEmployee.vue'
import MaintenStatistics from '../views/MaintenStatistics.vue'

import Maintenamce01 from '../views/Maintenance01.vue'
import ChangePermit from '../views/ChangePermit.vue'


import store from '../store'

import manEntryFlow  from '../manual/man-entry-flow.vue'
import manMyMachineEdit  from '../manual/man-mymachine-edit.vue'
import manAnalizeEntry  from '../manual/man-analize-entry.vue'
import manEmployeeAuth  from '../manual/man-employee-auth.vue'
import manEmployeeConfirm  from '../manual/man-employee-confirm.vue'
import manEmployeeGrant  from '../manual/man-employee-grant.vue'
import manEntryConfirm  from '../manual/man-entry-confirm.vue'
import manEntryPrint  from '../manual/man-entry-print.vue'
import manMyMachineQrPrint  from '../manual/man-mymachine-qr-print.vue'
import manSampleEntry  from '../manual/man-sample-entry.vue'
import manSampleQrPrint  from '../manual/man-sample-qr-print.vue'


Vue.use(VueRouter)
Vue.use(AmplifyPlugin, AmplifyModules);
Vue.use(Vuelidate)
Vue.use(moment)

Vue.config.productionTip = false

let languageDict = {
    ja:{
        'Sign in to your account' : 'OilMatrixにサインイン',
        'Username *' : 'ユーザ名（メールアドレス）',
        'Enter your username' : 'ユーザ名（メールアドレス）を入力してください',
        'Password *' : 'パスワード',
        'Enter your password' : 'パスワードを入力してください',
        'Forgot your password?' : 'パスワードを忘れた場合',
        'Reset your password' : 'パスワードのリセット',
        'Reset password' : 'パスワードのリセット',
        'No account? ' : '担当者登録がお済みでない方',
        'Create account' : '担当者の登録',
        'Create a new account' : '担当者のログイン情報の登録',
        'Sign In' : 'ログイン',
        'Sign in' : 'ログイン',
        'Back to Sign In' : 'ログインに戻る',
        'Have an account? ': '担当者情報が登録済みの方',
        'Enter new password': '新しいパスワードの設定',
        'New Password': '新しいパスワード',
        'SUBMIT': '実行',
        'Submit': '実行',
        'Confirm Sign Up': '本人確認（本登録）',
        'Confirmation Code': '本人確認コード',
        'Lost your code? ':  '本人確認コードがわからないか期限切れになってしまった場合は、新しい本人確認コードを再発行してください。（リンクをクリックすると本人確認コードメールが届きます。）',
        'Resend Code': 'あたらしい本人確認コードを再発行',
        'Invalid verification code provided, please try again.': '本人確認コードが間違っています。本人確認コードをご確認ください。',
        'Username cannot be empty': 'ユーザ名（メールアドレス）を入力してください',
        'User does not exist.': 'ユーザ名（メールアドレス）が登録されていません。',
        'Custom auth lambda trigger is not configured for the user pool.': 'ユーザ名（メールアドレス）とパスワードをご確認ください。',
        'Confirmation code cannot be empty': '本人確認コードを入力してください',
        'Incorrect username or password.': 'ユーザ名（メールアドレス）とパスワードが正しいかご確認ください',
        'CONFIRM': '本人確認（本登録）',
        'Confirm': '本人確認（本登録）',
        'Invalid code provided, please request a code again.': '本人確認コードの有効期限が切れています。本人確認コードを再発行して新しい本人確認コードでお試しください',
        'Attempt limit exceeded, please try after some time.': 'ログインエラー回数が規定回数を超えました。しばらくお時間をおいてからお試しください',
        'Cannot reset password for the user as there is no registered/verified email or phone_number': '本人確認（本登録）が完了しておりません。本人確認（本登録）のあとでお試しください。',
        'Send Code': "本人確認コードを送信",
        'Code': '本人確認コード'

    }
}
AmplifyModules.I18n.putVocabularies(languageDict)

const routes = [
  {
    path: '/',
    name: 'Home',
    component: MyPage,
    meta: { requiresAuth: true}
  },
  {
    path: '/staffpage',
    name: 'StaffPage',
    component: StaffPage,
    meta: { requiresAuth: true}
  },
  {
    path: '/mymachinelist',
    name: 'MyMachineList',
    component: MyMachineList,
    meta: { requiresAuth: true}
  },
  {
    path: '/deliverablelist',
    name: 'DeliverableList',
    component: DeliverableList,
    meta: { requiresAuth: true}
  },
  {
    path: '/myaircraft',
    name: 'MyAircraft',
    component: MyAircraft,
    meta: { requiresAuth: true, requiresAnalizeInfo: true}
  },
  {
    path: '/mymachine',
    name: 'MyMachine',
    component: MyMachine,
    meta: { requiresAuth: true, requiresAnalizeInfo: true}
  },
  {
    path: '/selectmachinetype',
    name: 'SelectMachineType',
    component: SelectMachineType,
    meta: { requiresAuth: true, requiresAnalizeInfo: true}
  },
  {
    path: '/selectapplicationtype',
    name: 'SelectApplicationType',
    component: SelectApplicationType,
    meta: { requiresAuth: true, requiresAnalizeInfo: true}
  },
  {
    path: '/selectquotetype',
    name: 'SelectQuoteType',
    component: SelectQuoteType,
    meta: { requiresAuth: true, requiresAnalizeInfo: true}
  },
  {
    path: '/selectspotsamplingtype',
    name: 'SelectSpotSamplingType',
    component: SelectSpotSamplingType,
    meta: { requiresAuth: true, requiresAnalizeInfo: true}
  },
  {
    path: '/mymachineqrcode',
    name: 'MyMachineQRCode',
    component: MyMachineQRCode,
    meta: { requiresAuth: true, requiresAnalizeInfo: true}
  },
  {
    path: '/sampling',
    name: 'Sampling',
    component: Sampling,
    meta: { requiresAuth: true, requiresAnalizeInfo: true}
  },
  {
    path: '/spotsampling',
    name: 'SpotSampling',
    component: SpotSampling,
    meta: { requiresAuth: true, requiresAnalizeInfo: true}
  },
  {
    path: '/application',
    name: 'Application',
    component: Application,
    meta: { requiresAuth: true, requiresAnalizeInfo: true}
  },
  {
    path: '/application_jxtg',
    name: 'ApplicationJXTG',
    component: ApplicationJXTG,
    meta: { requiresAuth: true, requiresAnalizeInfo: true}
  },
  {
    path: '/quote',
    name: 'Quote',
    component: Quote,
    meta: { requiresAuth: true, requiresAnalizeInfo: true}
  },
  {
    path: '/quotesheet',
    name: 'QuoteSeet',
    component: QuoteSeet,
    meta: { requiresAuth: true, requiresAnalizeInfo: true}
  },
  {
    path: '/referquote',
    name: 'ReferQuote',
    component: ReferQuote,
    meta: { requiresAuth: true}
  },
  {
    path: '/referapplication',
    name: 'ReferApplication',
    component: ReferApplication,
    meta: { requiresAuth: true, requiresAnalizeInfo: true}
  },
  {
    path: '/employeelist',
    name: 'EmployeeList',
    component: EmployeeList,
    meta: { requiresAuth: true}
  },
  {
    path: '/employee',
    name: 'Employee',
    component: Employee,
    meta: { requiresAuth: true}
  },
  {
    path: '/ordersheet',
    name: 'OrderSheet',
    component: OrderSheet,
    meta: { requiresAuth: true, requiresAnalizeInfo: true}
  },
  {
    path: '/ordersheet4labelsheet',
    name: 'OrderSheet4LabelSheet',
    component: OrderSheet4LabelSheet,
    meta: { requiresAuth: true, requiresAnalizeInfo: true}
  },
  {
    path: '/ordersheet4labelsheetJET',
    name: 'OrderSheet4LabelSheetJET',
    component: OrderSheet4LabelSheetJET,
    meta: { requiresAuth: true, requiresAnalizeInfo: true}
  },
  {
    path: '/ordersheet4labelsheetFrame',
    name: 'OrderSheet4LabelSheetFrame',
    component: OrderSheet4LabelSheetFrame,
    meta: { requiresAuth: true, requiresAnalizeInfo: true}
  },
  {
    path: '/barcodesheet',
    name: 'BarCodeSheet',
    component: BarCodeSheet,
    meta: { requiresAuth: true, requiresAnalizeInfo: true}
  },
  {
    path: '/auth',
    name: 'CustomAuth',
//    component: components.Authenticator
    component: CustomAuth
  },
  {
    path: '/changePassword',
    name: 'CustomChangePassword',
//    component: components.Authenticator
    component: CustomChangePassword
  },
  {
    path: '/FAQ',
    name: 'FAQ',
    component: FAQ
  },
  {
    path: '/changeOffice',
    name: 'ChangeOffice',
//    component: components.Authenticator
    component: ChangeOffice
  },
  {
    path: '/barcodesample',
    name: 'BarCodeSample',
    component: BarCodeSample,
  },
  {
    path: '/maintenance',
    name: 'MaintenamceMenu',
    component: MaintenamceMenu,
  },
  {
    path: '/mainteanalizeset',
    name: 'MainteAnalizeSet',
    component: MainteAnalizeSet,
  },
  {
    path: '/mainteanalizeitem',
    name: 'MainteAnalizeItem',
    component: MainteAnalizeItem,
  },
  {
    path: '/mainteinformation',
    name: 'MainteInformation',
    component: MainteInformation,
  },
  {
    path: '/mainteoutbox',
    name: 'MainteOutbox',
    component: MainteOutbox,
  },
  {
    path: '/maintedeliverables',
    name: 'MainteDeliverables',
    component: MainteDeliverables,
  },
  {
    path: '/maintecompany',
    name: 'MainteCompany',
    component: MainteCompany,
  },
  {
    path: '/mainteemployee',
    name: 'MainteEmployee',
    component: MainteEmployee,
  },
  {
    path: '/maintenstatistics',
    name: 'MaintenStatistics',
    component: MaintenStatistics,
  },
  {
    path: '/maintenance01',
    name: 'Maintenamce01',
    component: Maintenamce01,
  },
  {
    path: '/changePermit',
    name: 'ChangePermit',
    component: ChangePermit,
  },
  {
    path: '/UserManual',
    // name: 'UserManual',
    component: UserManual,
    children: [
      {
        path: '',
        component: manEntryFlow,
        name: 'manEntryFlow'
      },
      {
        path: 'manMyMachineEdit',
        component: manMyMachineEdit,
        name: 'manMyMachineEdit'
      },
      {
        path: 'manAnalizeEntry',
        component: manAnalizeEntry,
        name: 'manAnalizeEntry'
      },
      {
        path: 'manEmployeeAuth',
        component: manEmployeeAuth,
        name: 'manEmployeeAuth'
      },
      {
        path: 'manEmployeeConfirm',
        component: manEmployeeConfirm,
        name: 'manEmployeeConfirm'
      },
      {
        path: 'manEmployeeGrant',
        component: manEmployeeGrant,
        name: 'manEmployeeGrant'
      },
      {
        path: 'manEntryConfirm',
        component: manEntryConfirm,
        name: 'manEntryConfirm'
      },
      {
        path: 'manEntryPrint',
        component: manEntryPrint,
        name: 'manEntryPrint'
      },
      {
        path: 'manMyMachineQrPrint',
        component: manMyMachineQrPrint,
        name: 'manMyMachineQrPrint'
      },
      {
        path: 'manSampleEntry',
        component: manSampleEntry,
        name: 'manSampleEntry'
      },
      {
        path: 'manSampleQrPrint',
        component: manSampleQrPrint,
        name: 'manSampleQrPrint'
      },
    ],
  },
]

const router = new VueRouter({
  scrollBehavior (to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition
    } else {
      return { x: 0, y: 0 }
    }
  },  
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})

let user;
getUser().then((user, error) => { // eslint-disable-line
//  if (user) {
//    router.push({path: '/'})
//  }
})


//AmplifyEventBus.$on('authState', async (state) => {
//  console.log('■■ AmplifyEventBus.$on', state)
//  if (state === 'signedOut'){
//    user = null;
//    router.push({path: '/auth'})
//  } else if (state === 'signedIn') {
//    user = await getUser();
//    router.push({path: '/'})
//  }
//});

// ログイン状態管理
Hub.listen("auth", async (data) => {
    console.log('■■ Hub.listen.$on', data)
    if (data.payload.event === 'signOut'){
        user = null;
//        store.commit('setUser', null);
        router.push({path: '/auth'});
    } else if (data.payload.event === 'signIn') {
        user = await getUser();
        router.push({path: '/'});
    }
});



function getUser() {
  return Vue.prototype.$Amplify.Auth.currentAuthenticatedUser().then((data) => {
    if (data && data.signInUserSession) {
      return data;
    } 
  }).catch((e) => { // eslint-disable-line
    return null
  });
}

router.beforeResolve(async (to, from, next) => {
  if (to.matched.some(record => record.meta.requiresAuth)) {
    user = await getUser();
    if (!user) {
      store.state.redirectpath = to.fullPath
      return next({
        path: '/auth',
        query: {
          redirect: to.fullPath,
        }
      });
    }
    // ユーザ情報のstoreへの初期設定が完了するまで待つ
    while(store.state.initializedUser == false) {
      console.log("■■ standby InitUser wait", store.state.initializedUser)
      await sleep(100);
    }

    // redirectpathが設定されていた場合（未ログインで採油画面に飛んできたとき）
    // todo ログインのリダイレクト中に別のページにリダイレクトするので、vueに怒られているけれども無視している。対処方法がわからなかったので
    if(store.state.redirectpath) {
      const _path = store.state.redirectpath
      store.state.redirectpath = null
//      return next({
//        path: _path
//      });
      router.push(_path)
      .catch()
    }

    // 分析関連情報の初期化が必須の画面の場合、分析情報の初期化が完了するまで待つ
    if (to.matched.some(record => record.meta.requiresAnalizeInfo)) {
      while(store.state.initializedAnalize == false) {
        console.log("■■ standby AnalizeInfo wait", store.state.initializedAnalize)
        await sleep(100);
      }
    }
    console.log("■■ standby AnalizeInfo", store.state.initializedAnalize)

    return next()
  }
  return next()
})

const sleep = msec => new Promise(resolve => setTimeout(resolve, msec));

export default router
